import React from "react";

export interface PublicAppConfig {
    publicDeliveryConfig: PublicDeliveryConfig;
    publicApiKeyValue: string;
}

export interface PublicDeliveryConfig {
    apiUrl: string;
}

export const PublicConfigurationContext = React.createContext<PublicAppConfig>({
    publicDeliveryConfig: { apiUrl: "" },
    publicApiKeyValue: ""
});
